import { UserCenterService } from './user-center';
import { Account, getAccountInfo, getBasicAccountInfo, getNewProducts, getTenants, postLoginSuccessPageApi, postSwitchTenant } from './apis';
import { Site, SLD, transformUrlProxy } from './site';
import { config } from './config';
export class HeaderService {
    static getHelpCenterMenuItems() {
        return [
            {
                key: 'helpCenter',
                icon: 'SolidHelpCentre',
                label: 'Help center',
            },
            {
                key: 'beginnerUser',
                icon: 'SolidTextFile',
                label: 'Beginner',
                onlyCn: true,
            },
            {
                key: 'startVideos',
                icon: 'SolidVideoExist',
                label: 'Getting Started videos',
                onlyAbroad: true,
            },
            {
                key: 'searchHelper',
                icon: 'SolidSearchLeft',
                label: 'Search Helper',
            },
            {
                key: 'releaseLog',
                icon: 'SolidCalendar7',
                label: 'Release Log',
            },
            {
                key: 'data',
                icon: 'SolidGlobal',
                label: 'Data Coverage',
            },
            {
                key: 'askForHelp',
                icon: 'SolidConversation',
                label: 'Ask for help',
                onlyAbroad: true,
            },
        ];
    }
    /**
     * 是否可使用通知中心，需要同时满足通知中心可见、非特殊 IP、已登录
     */
    get canUseNotifications() {
        var _a, _b;
        return this.notificationsVisible && !((_a = this.account) === null || _a === void 0 ? void 0 : _a.isSpecialIp) && ((_b = this.account) === null || _b === void 0 ? void 0 : _b.isLogin);
    }
    t(chain) {
        return chain;
    }
    constructor(title = '') {
        this.title = title;
        this.left = [];
        this.right = [];
        this.type = 'plain';
        /**
         * 是否显示 logo
         */
        this.logoVisible = true;
        /**
         * 是否显示自定义 logo
         */
        this.customLogoVisible = true;
        /**
         * 是否展示产品列表
         */
        this.visibleProducts = true;
        /**
         * 挂载节点或节点的选择器
         */
        this.mountElement = '#header-wrapper';
        /**
         * 是否展示帮助中心指引链接
         */
        this.helpCenterGuiderVisible = false;
        /**
         * 帮助中心指引链接配置
         */
        this.helpCenterGuiderConfig = {
            module: '',
            subModule: '',
            serviceArea: ''
        };
        /**
         * 是否展示通知中心
         */
        this.notificationsVisible = true;
        this.wujieStartOption = {};
        this.beforeLocaleChange = (_key, done) => { done(); };
        this._locales = [
            { key: 'en', label: 'English', active: true },
            { key: 'cn', label: '简体中文' },
            { key: 'tw', label: '繁體中文' },
            { key: 'jp', label: '日本語' },
        ];
        /**
         * logo 链接
         */
        this.logoHref = 'javascript: void 0;';
        this.account = undefined;
        /**
         * axios 实例，可用于 header 及其附属组件的数据请求
         */
        this.axios = undefined;
        /**
         * 是否展示切换租户弹框
         */
        this._switchTenantDialogVisible = false;
        /**
         * 当前正在切换的租户
         */
        this._currentSwitchTenantInfo = undefined;
        this.switchTenantHandler = async (_key, done) => {
            const { token } = await done();
            const { page, product } = await postLoginSuccessPageApi({
                ...this.lastSyncOpt,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }, {
                last_page: '' // 跳转到有权限的产品页,last_page不设值
            });
            if (window.location.search.indexOf('noRaven') !== -1) {
                throw new Error('Switch tenant: local stop redirect');
            }
            window.location.href = product ? transformUrlProxy(product, page) : page;
        };
        //#region 新产品
        this._newProducts = [];
        this.title = title;
        this.userCenterService = new UserCenterService();
        this.syncing = false;
        this.deferred = (() => {
            /**
             * reference: https://github.com/moll/js-promise-defer/blob/master/index.js
             */
            let deferred = Object.create({});
            deferred.promise = new Promise(function (resolve, reject) {
                deferred.resolve = resolve;
                deferred.reject = reject;
            });
            return deferred;
        })();
    }
    set logo(visible) {
        console.warn('[Deprecation] Use "logoVisble" instead');
        this.logoVisible = visible;
    }
    get logo() {
        console.warn('[Deprecation] Use "logoVisble" instead');
        return this.logoVisible;
    }
    get currentActiveLanguage() {
        var _a;
        return (_a = this._locales.find(item => item.active)) === null || _a === void 0 ? void 0 : _a.key;
    }
    set locales(locales) {
        this._locales = locales;
    }
    get locales() {
        return this._locales;
    }
    get whiteLabel() {
        var _a;
        return (_a = this.account) === null || _a === void 0 ? void 0 : _a.whiteLabel;
    }
    get isHighLevelWhiteLabel() {
        var _a;
        return !!((_a = this.account) === null || _a === void 0 ? void 0 : _a.isHighLevelWhiteLabel);
    }
    get customLogoUrl() {
        var _a;
        return (_a = this.account) === null || _a === void 0 ? void 0 : _a.customLogoUrl;
    }
    get customWhiteLogoUrl() {
        var _a;
        return (_a = this.account) === null || _a === void 0 ? void 0 : _a.customWhiteLogoUrl;
    }
    get tenants() {
        var _a;
        return (_a = this.account) === null || _a === void 0 ? void 0 : _a.tenants;
    }
    /**
     * 检查是否有 logo 或者 title 显示
     * @param slotLogo 是否提供了 logo 插槽
     * @returns
     */
    checkLogoOrTitleVisible(slotLogo) {
        if (this.title) {
            return true;
        }
        if (slotLogo && this.logoVisible) {
            return true;
        }
        if (this.whiteLabel && this.customLogoVisible) {
            return true;
        }
        return false;
    }
    setLocale(localeKey) {
        this.beforeLocaleChange(localeKey, () => {
            this.locales = this.locales.map((item) => {
                const { active, ...rest } = item;
                return {
                    ...rest,
                    active: rest.key === localeKey
                };
            });
        });
    }
    set switchTenantDialogVisible(visible) {
        this._switchTenantDialogVisible = visible;
    }
    get switchTenantDialogVisible() {
        return this._switchTenantDialogVisible;
    }
    /**
     * 设置当前切换的租户弹框的信息
     */
    set currentSwitchTenantInfo(tenant) {
        this._currentSwitchTenantInfo = tenant;
    }
    /**
     * 获取当前切换的租户弹框的信息
     */
    get currentSwitchTenantInfo() {
        return this._currentSwitchTenantInfo;
    }
    switchTenants(tenant_id) {
        /* 构造 passport 地址 */
        const { href } = new Site({ sld: SLD.PASSPORT });
        return this.switchTenantHandler(tenant_id, async () => {
            return await postSwitchTenant({
                http: this.axios,
                uri: href
            }, {
                client_id: config.clientId,
                from: config.clientName,
                tenant_id,
                individual: !tenant_id
            });
        });
    }
    set newProducts(products) {
        this._newProducts = products;
    }
    get newProducts() {
        return this._newProducts;
    }
    get hasNewProducts() {
        return this._newProducts.length > 0;
    }
    getNewProducts(opt) {
        return getNewProducts(opt).then((data) => {
            this.newProducts = data;
            return data;
        });
    }
    //#endregion
    sync(opt) {
        let http;
        if (typeof opt === 'function') {
            http = opt;
        }
        else {
            this.axios = opt.http;
            this.lastSyncOpt = opt;
            http = () => getAccountInfo(opt);
        }
        this.syncing = true;
        Promise.all([
            /**
             * 获取account基础信息
             * 包含 account_id、avatar、avatar_color、avatar_pattern、company_id、company_name、email、mobile_number、nickname、site_region、special_ip
             */
            getBasicAccountInfo(opt),
            getTenants(opt),
            /**
             * 获取除用户信息之外的内容
             */
            http()
        ]).then(([basic, tenants, additional]) => {
            const info = { ...basic, tenants, ...additional };
            this.account = new Account(info);
            const name = info.nickname || info.email;
            const tenantName = info.company_name || info.nickname || info.email || info.mobile_number || info.account_id;
            if (info.account_id && !info.special_ip) {
                /* 设置登陆 */
                this.userCenterService.login({
                    id: info.account_id,
                    name,
                    avatar: info.avatar,
                    avatarColor: info.avatar_color,
                    adminConsole: info.admin_console,
                    tenantName,
                    companyId: info.company_id,
                    mobileNumber: info.mobile_number,
                });
            }
            /* 设置用户菜单 */
            this.userCenterService.beforeRenderMenuItems = (items) => {
                return items.filter(item => {
                    if (item.key === 'timer' && !info.project_timer)
                        return false;
                    if (item.key === 'settings' && !info.admin_console)
                        return false;
                    if (item.key === 'team' && !info.company_id)
                        return false;
                    return true;
                });
            };
            return this.deferred.resolve(info);
        }).finally(() => {
            this.syncing = false;
        });
        return this.deferred.promise;
    }
}
//# sourceMappingURL=header.js.map